import { computed, useRoute } from '#imports'
import {
    getLegalPageContext,
    getLegalTextParams,
    LEGAL_ENTITIES,
} from '~/utils/legal-entity'

export function useLegalEntity() {
    const route = useRoute()
    const legalEntity = computed(() => {
        const platform = getLegalPageContext(route.path)?.platform || 'app'
        return LEGAL_ENTITIES[platform]
    })
    const legalTextParams = computed(() => getLegalTextParams(route.path))

    return { legalEntity, legalTextParams }
}
